import { login as sessionLogin, logout as sessionLogout } from '@/plugins/sessionAuth.js';

/**
 * Auth actions — Sanctum SPA cookie auth.
 */
export default {
  /**
   * Login via POST /user/login (Sanctum SPA).
   * Payload: { username (email), password }
   */
  async login({ commit, dispatch }, { username, password, remember = false } = {}) {
    await sessionLogin(username, password, remember);
    await dispatch('user/getUser', null, { root: true });
    commit('setAuthenticated', true);
  },

  /**
   * Sincronizza lo stato auth all'avvio (App.vue created()).
   * GET /user/user → se ok, popola lo store utente.
   */
  async tryLogin(context) {
    try {
      await context.dispatch('user/getUser', null, { root: true });
      context.commit('setAuthenticated', true);
    } catch (e) {
      // Non autenticato o errore → nessuna azione, il guard router reindirizza
      console.debug('tryLogin: getUser fallito', e.message);
    }
  },

  /**
   * Logout via POST /user/logout + reset store.
   */
  async logout(context) {
    try {
      await sessionLogout();
    } catch (e) {
      console.debug('logout: errore server', e.message);
    }
    context.commit('reset');
    window.location.href = '/login';
  },

  /**
   * Sessione persa lato app: marca didAutoLogout (App.vue reagisce → redirect /login).
   */
  autoLogout(context) {
    context.commit('setAutoLogout');
  },
};
